














































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {deleteCoupons} from '@/ts/coupons/delete-coupons';
import {getCoupons} from '@/ts/coupons/get-coupons';
import {reformatDate} from '@/ts/helpers';

export default {
    name: 'TheTableCoupons',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        date(date) {
            return reformatDate(date);
        },
        fireModal(id) {
            this.$swal.fire({
                title: 'Внимание!',
                text: 'Това действие е необратимо, желаете ли да продължите?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отказ',
                confirmButtonText: 'Изтриване',
            }).then((result) => {
                if (result.value) {
                    deleteCoupons(this.$route.params.id, id).then(() => {
                        this.$swal.fire(
                            'Изтриването успешно!',
                            '',
                            'success',
                        );
                        const index = this.$store.state.response.response.findIndex((item) => item.id === id);
                        this.$store.state.response.response.splice(index, index);
                    });
                }
            });
        },
        sort(temp) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setOrderParam', temp.order_param);
            this.$store.dispatch('setSortParam', temp.sort_param);
            getCoupons(this.$route.params.id).then(() => {
                this.$store.dispatch('setLoadingOn');
            });
        },
    },
};
